import SpjIndex from '@/views/spj/SpjIndex.vue';
import SpjForm from '@/views/spj/SpjForm.vue';

export default [
    {
        path: '/spj',
        name: 'spj',
        component: SpjIndex,
        meta: {
            title: 'SPJ Management',
            requiresAuth: true,
            role: ['Admin', 'Super Admin','Manager Driver'],
        }
    },
    {
        path: '/spj/add',
        name: 'spj-add',
        component: SpjForm,
        meta: {
            title: 'Add SPJ',
            requiresAuth: true,
            role: ['Admin Office', 'Super Admin','Manager Driver'],
        }
    },
    {
        path: '/spj/edit/:uuid',
        name: 'spj-edit',
        component: SpjForm,
        meta: {
            title: 'Edit SPJ',
            requiresAuth: true,
            role: ['Admin Office', 'Super Admin','Manager Driver'],
        }
    },
    {
        path: '/spj/detail/:uuid',
        name: 'spj-detail',
        component: () => import('@/views/spj/SpjDetail.vue'),
        meta: {
            title: 'SPJ Detail',
            requiresAuth: true,
            role: ['Admin Office', 'Super Admin','Manager Driver'],
        }
    },
    {
        path: '/spj/add-new',
        name: 'spj-add-new',
        component: () => import('@/views/spj/SpjFormNew.vue'),
        meta: {
            title: 'Create SPJ (New Layout)',
            requiresAuth: true,
            role: ['Admin Office', 'Super Admin','Manager Driver'],
        }
    }
];